function onReady() {
    if (window.acf) {
        let hasInitAdmin = false
        function onReady() {
            if (hasInitAdmin) return;
            hasInitAdmin = true
        }
        window.acf.addAction(`render_block_preview`, onReady)
    }
    else {

        // const $lazy = document.querySelectorAll('[decoding="async"]');
        // $lazy?.forEach(el => {
        //     el.removeAttribute('decoding');
        // });

        // $lazy?.forEach(el => {
        //     el.removeAttribute('loading');
        //     el.style.filter = 'blur(20px)';
        //     // if ( el.hasAttribute('src') ) {
        //     //     el.setAttribute('data-src', el.getAttribute('src') );
        //     //     el.removeAttribute('src');
        //     // }
        //     if ( el.hasAttribute('srcset') ) {
        //         el.setAttribute('data-srcset', el.getAttribute('srcset') );
        //         el.removeAttribute('srcset');
        //     }
        // });
        
        // let observer = new IntersectionObserver( onIntersect );

        // function onIntersect(entries) {
        //     entries.forEach(entry => {
        //         if (entry.isIntersecting) {
        //             // if (!entry.target.hasAttribute('src') && entry.target.hasAttribute('data-src')) {
        //             //     entry.target.setAttribute('src', entry.target.getAttribute('data-src') )
        //             // }
        //             if (!entry.target.hasAttribute('srcset') && entry.target.hasAttribute('data-srcset')) {
        //                 entry.target.setAttribute('srcset', entry.target.getAttribute('data-srcset') )
        //                 entry.target.style.filter = 'none';
        //             }
        //         }
        //     });
        // }

        // $lazy.forEach(el => observer.observe(el) )

        // function onResize() {
        //     $lazy.forEach(el => observer.unobserve(el) )
        //     observer = new IntersectionObserver( onIntersect, {});
        //     $lazy.forEach(el => observer.observe(el) )
        // }

        // const resizeObserver = new ResizeObserver(entries => {
        //     onResize()
        // });
        // resizeObserver.observe(document.body);
        // window.addEventListener('resize', onResize);

    }
}

if (document.readyState === 'complete') {
    onReady()
}
else {
    window.addEventListener("DOMContentLoaded", onReady );
}

export default {}